import React from 'react';
import Education from '../Education';
import Experience from '../Experience';
import Banner from './Banner';
import Contact from './Contact';
import Projects from './Projects.js';
import Skills from './Skills';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <Skills></Skills>
            <Experience></Experience>
            <Education></Education>
            <Projects></Projects>
            <Contact></Contact>
            
        </div>
    );
};

export default Home;